module.exports = __webpack_public_path__ + "34b421e70861cfb9fd1d587de9c893d3.svg";